import { render } from "./PageDownload.vue?vue&type=template&id=5f8b306f"
import script from "./PageDownload.vue?vue&type=script&lang=js"
export * from "./PageDownload.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__